import { mapPlatformIdsToBlogger, mapPlatformIdsToMediaPerson } from '../utils';
import { Platform } from '../types';

export const YOUTUBE_AUTH_TOKEN_KEY = 'youtubeAuthToken';
export const YOUTUBE_CHANNELS_CONFIG = {
  ...mapPlatformIdsToMediaPerson(Platform.Youtube),
  ...mapPlatformIdsToBlogger(Platform.Youtube),
};
